import { render, staticRenderFns } from "./ViewsWidget.vue?vue&type=template&id=1e6364bf"
import script from "./ViewsWidget.vue?vue&type=script&lang=js"
export * from "./ViewsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports